import PropTypes from 'prop-types';
import React from 'react';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import uuid from 'uuid';

import withTranslations from '../../../common/components/utils/Translations/withTranslations';
import { handleFormErrors } from '../../../common/errors';
import propTypes from '../../../common/propTypes';
import continueCurrentUserPasswordReset from './continueCurrentUserPasswordReset.graphql';
import RestrictedOperationConfirmation from '../RestrictedOperationConfirmation';
import UpdatePasswordForm from './UpdatePasswordForm';
import updateUserPasswordGql from './updateUserPassword.graphql';
import { UPDATE_PASSWORD_AREA } from '../const';

const defautlUpdatePasswordEntity = {
  newPassword: '',
  currentPassword: '',
  passwordConfirmation: '',
};

@withRouter
@withTranslations
@graphql(updateUserPasswordGql, { name: 'updateUserPassword' })
@graphql(continueCurrentUserPasswordReset, {
  name: 'continueCurrentUserPasswordReset',
})
export default class UpdatePassword extends React.PureComponent {
  static propTypes = {
    updateUserPassword: PropTypes.func.isRequired,
    continueCurrentUserPasswordReset: PropTypes.func.isRequired,
    ...propTypes.routePropTypes,
    ...propTypes.translatePropTypes,
  };

  constructor(props) {
    super(props);

    this.state = {
      entity: { id: uuid.v4(), ...defautlUpdatePasswordEntity },
      status: null,
    };
  }

  handleUpdatePasswordSubmit = async ({ currentPassword, newPassword }) => {
    const { updateUserPassword, t } = this.props;
    const { data } = await handleFormErrors(
      updateUserPassword({
        variables: {
          currentPassword,
          newPassword,
          areaKey: UPDATE_PASSWORD_AREA,
        },
      }),
      t,
    );
    this.processResponse(data.initiateCurrentUserPasswordReset);
  };

  handleConfirmation = async ({ emailConfirmationToken }) => {
    const { continueCurrentUserPasswordReset, t } = this.props;
    const { data } = await handleFormErrors(
      continueCurrentUserPasswordReset({
        variables: {
          emailConfirmationToken,
        },
      }),
      t,
    );

    this.processResponse(data.continueCurrentUserPasswordReset);
    return data.continueCurrentUserPasswordReset;
  };

  processResponse(status) {
    const { pendingEmailConfirmation } = status;

    if (pendingEmailConfirmation) {
      this.setState({ status });
    } else {
      this.setState({
        status: null,
        entity: { id: uuid.v4(), ...defautlUpdatePasswordEntity },
      });
    }
  }

  handleCancelConfirmation = () => {
    this.setState({ status: null });
  };

  getMessage = () => {
    const { status } = this.state;
    let message;
    if (status && status.pendingEmailConfirmation) {
      message = 'Verification Code Sent';
    }
    return message;
  };

  render() {
    const { status, entity } = this.state;
    return (
      <>
        <UpdatePasswordForm
          withoutNotifications
          columns={1}
          entity={entity}
          entityName="update-password"
          updateMessageText={this.getMessage()}
          onSubmit={this.handleUpdatePasswordSubmit}
        />
        <RestrictedOperationConfirmation
          operationStatus={status}
          updateMessageText="Password Updated Successfully"
          onCancel={this.handleCancelConfirmation}
          onConfirm={this.handleConfirmation}
        />
      </>
    );
  }
};
